<template>
  <div class="about-nlite-page">
    <navbar
      is-blur="blur blur-rounded my-3 py-2 start-0 end-0 shadow"
      btn-background="bg-gradient-success"
      :dark-mode="true"
    />
    <section class="nlite-hero">
      <div class="container h-100">
        <div class="row align-items-center h-100">
          <div class="col-lg-6 hero-content">
            <div class="brand-logo mb-4">
              <img :src="require('@/assets/img/logo_nlite.png')" alt="N'Lite Logo" class="nlite-logo">
            </div>
            
            <h1 class="hero-title text-white mb-4">
              Vos transferts d'argent,<br>
              simplifiés et accessibles 
              <span class="position-relative d-inline-block">
                24h/24
                <svg class="underline-svg" viewBox="0 0 120 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 5C30 8 90 2 118 5" stroke="#F5A847" stroke-width="3" stroke-linecap="round"/>
                </svg>
              </span>
            </h1>
            
            <p class="hero-desc text-white opacity-8 mb-5">
              Avec N'Lite, envoyez et recevez de l'argent en toute simplicité, que ce soit 
              au niveau national, régional ou international. Une application conçue pour 
              répondre à tous vos besoins de paiement et de transfert, en un seul 
              endroit. Profitez de transactions instantanées et d'une interopérabilité 
              totale avec les acteurs Mobile Money et bancaires
            </p>
            
            <custom-button label="Télécharger l'App" variant="white" class="hero-btn" />
          </div>
          
          <div class="col-lg-6 position-relative h-100">
            <div class="hero-image-wrapper">
              <img :src="require('@/assets/img/Illustration.png')" alt="N'Lite App" class="hero-illustration-img">
            </div>
          </div>
        </div>
      </div>
    </section>
    <main class="main-content position-relative border-radius-lg">
      <div class="container py-5">
        <!-- Section Header -->
        <div class="row justify-content-center text-center mb-5">
          <div class="col-lg-8">
            <span class="text-uppercase text-secondary font-weight-bold tracking-wide" style="letter-spacing: 2px; font-size: 0.85rem;">Nos fonctionnalités clés</span>
            <h2 class="mt-3 mb-4 display-5 fw-bold" style="color: #2F2113;">
              Conçue pour répondre à<br>
              <span class="position-relative d-inline-block">
                tous vos besoins
                <svg class="underline-svg-title" viewBox="0 0 200 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 10 C 60 12 140 12 195 5" stroke="#F5A847" stroke-width="4" stroke-linecap="round"/>
                </svg>
              </span>
            </h2>
          </div>
        </div>

          <!-- Feature 1 -->
        <div class="row align-items-center mb-6">
          <div class="col-lg-6 mb-4 mb-lg-0 position-relative">
            <div class="blob-bg blob-left"></div>
            <div class="text-center position-relative z-index-2">
              <img :src="require('@/assets/img/Container (7).png')" class="feature-img rounded-3" alt="Transferts">
            </div>
          </div>
          <div class="col-lg-6 ps-lg-5">
            <h3 class="fw-bold mb-3 position-relative d-inline-block" style="color: #2F2113;">
              Transferts nationaux, régionaux<br>et internationaux
              <svg class="underline-svg-feature" viewBox="0 0 300 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 10 C 100 12 200 12 295 5" stroke="#F5A847" stroke-width="3" stroke-linecap="round"/>
              </svg>
            </h3>
            <ul class="list-unstyled mt-4 text-secondary">
              <li class="mb-3 d-flex align-items-start">
                <span class="me-2">•</span>
                Envoyez de l'argent à vos proches ou payez vos factures, où que vous soyez
              </li>
              <li class="mb-3 d-flex align-items-start">
                <span class="me-2">•</span>
                 Demande de paiements internationaux en quelques clics
              </li>
            </ul>
          </div>
        </div>

        <!-- Feature 2 -->
        <div class="row align-items-center mb-6">
          <div class="col-lg-6 order-lg-2 mb-4 mb-lg-0 position-relative text-center">
            <div class="blob-bg blob-right"></div>
            <div class="text-center position-relative z-index-2">
              <img :src="require('@/assets/img/Container (3).png')" class="feature-img rounded-3" alt="Transactions">
            </div>
          </div>
          <div class="col-lg-6 order-lg-1 pe-lg-5">
            <h3 class="fw-bold mb-3 position-relative d-inline-block" style="color: #2F2113;">
              Transactions instantanées<br>et sécurisées
              <svg class="underline-svg-feature" viewBox="0 0 250 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 10 C 80 12 160 12 245 5" stroke="#F5A847" stroke-width="3" stroke-linecap="round"/>
              </svg>
            </h3>
            <ul class="list-unstyled mt-4 text-secondary">
              <li class="mb-3 d-flex align-items-start">
                <span class="me-2">•</span>
                Bénéficiez de transferts 24h/24, avec une sécurité renforcée et conforme aux normes réglementaires
              </li>
            </ul>
          </div>
        </div>

        <!-- Feature 3 -->
        <div class="row align-items-center mb-6">
          <div class="col-lg-6 mb-4 mb-lg-0 position-relative">
            <div class="blob-bg blob-left"></div>
            <div class="text-center position-relative z-index-2">
              <img :src="require('@/assets/img/Container (4).png')" class="feature-img rounded-3" alt="Interoperabilité">
            </div>
          </div>
          <div class="col-lg-6 ps-lg-5">
            <h3 class="fw-bold mb-3 position-relative d-inline-block" style="color: #2F2113;">
              Interopérabilité totale
              <svg class="underline-svg-feature" viewBox="0 0 200 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 10 C 60 12 140 12 195 5" stroke="#F5A847" stroke-width="3" stroke-linecap="round"/>
              </svg>
            </h3>
            <ul class="list-unstyled mt-4 text-secondary">
              <li class="mb-3 d-flex align-items-start">
                <span class="me-2">•</span>
                Compatible avec tous les acteurs (Mobile Money, banques, IMF) dans la zone UEMOA et au-delà
              </li>
            </ul>
          </div>
        </div>

        <!-- Interface Intuitive -->
        <div class="row align-items-center mb-6">
          <div class="col-lg-6 order-lg-2 mb-4 mb-lg-0 position-relative text-center">
            <div class="blob-bg blob-right"></div>
            <div class="text-center position-relative z-index-2">
              <img :src="require('@/assets/img/Container (5).png')" class="feature-img rounded-3" alt="Interface">
            </div>
          </div>
          <div class="col-lg-6 order-lg-1 pe-lg-5">
            <h3 class="fw-bold mb-3 position-relative d-inline-block" style="color: #2F2113;">
              Une interface intuitive<br>pour tous
              <svg class="underline-svg-feature" viewBox="0 0 250 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 10 C 80 12 160 12 245 5" stroke="#F5A847" stroke-width="3" stroke-linecap="round"/>
              </svg>
            </h3>
            <ul class="list-unstyled mt-4 text-secondary">
              <li class="mb-3 d-flex align-items-start">
                <span class="me-2">•</span>
                Conçue pour les particuliers, N'Lite offre une expérience fluide et accessible, sans complexité
              </li>
            </ul>
          </div>
        </div>

        <!-- Reprenez le contrôle section -->
        <div class="text-center mb-6">
          <h2 class="display-5 fw-bold mb-3" style="color: #2F2113;">
            Reprenez le contrôle de<br>
            <span class="position-relative d-inline-block">
              votre argent
              <svg class="underline-svg-title" viewBox="0 0 200 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 10 C 60 12 140 12 195 5" stroke="#F5A847" stroke-width="4" stroke-linecap="round"/>
                </svg>
            </span>
          </h2>
          <p class="text-secondary mb-4">Vos finances en toute simplicité, sécurité et transparence</p>
          <div class="mb-5">
            <custom-button label="Télécharger l'App" />
          </div>

          <div class="row justify-content-center">
            <div class="col-md-4 mb-4">
              <div class="p-5 h-100 text-center gray-card">
                <img :src="require('@/assets/img/secC.png')" class="mb-4" alt="Aggrégation" style="max-height: 120px;">
                <h5 class="fw-bold mb-2">Aggrégation de comptes</h5>
                <p class="small text-secondary">N'Lite vous permet de connecter et visualiser tous vos comptes (Mobile Money, comptes bancaires)</p>
              </div>
            </div>
            <div class="col-md-4 mb-4">
              <div class="p-5 h-100 text-center gray-card">
                <img :src="require('@/assets/img/secB.png')" class="mb-4" alt="Protégez" style="max-height: 120px;">
                <h5 class="fw-bold mb-2">Protégez - fructifier</h5>
                <p class="small text-secondary">Nous vous proposons des solutions d'épargne adaptées pour préparer l'avenir ainsi que des offres d'assurance</p>
              </div>
            </div>
            <div class="col-md-4 mb-4">
              <div class="p-5 h-100 text-center gray-card">
                <img :src="require('@/assets/img/secA.png')" class="mb-4" alt="Sécurité" style="max-height: 120px;">
                <h5 class="fw-bold mb-2">Une sécurité renforcée</h5>
                <p class="small text-secondary">Grâce à notre processus KYC rigoureux, nous vérifions et protégeons chaque compte pour éviter les fraudes</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Transferts Internationaux Section -->
        <div class="row align-items-center mb-6">
          <div class="col-lg-6 mb-4 mb-lg-0">
             <img :src="require('@/assets/img/image_droite_section_1.png')" class="w-100 rounded-3" alt="Transferts Internationaux">
          </div>
          <div class="col-lg-6 ps-lg-5">
            <h3 class="fw-bold mb-5 position-relative d-inline-block text-dark-brown">
              Transferts internationaux<br>sans frontières
              <svg class="underline-svg-feature" viewBox="0 0 300 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 8 C 50 10, 250 10, 295 8" stroke="#F5A847" stroke-width="4" stroke-linecap="round"/>
              </svg>
            </h3>
            
            <div class="d-flex mb-4">
              <div class="me-4">
                 <div class="icon-box rounded-circle d-flex align-items-center justify-content-center" style="width: 64px; height: 64px; background: #F4F6F8;">
                    <img :src="require('@/assets/img/Icon Container (3).png')" alt="Solution universelle" style="width: 32px; height: auto;">
                 </div>
              </div>
              <div>
                <h6 class="fw-bold mb-2 text-dark-brown">Une solution universelle</h6>
                <p class="text-secondary mb-0" style="font-size: 0.95rem; line-height: 1.6;">Payer et envoyer de l'argent depuis n'importe quel pays Avec N’Lite, utilisez simplement votre carte pour effectuer des transferts internationaux</p>
              </div>
            </div>

            <div class="d-flex mb-5">
              <div class="me-4">
                 <div class="icon-box rounded-circle d-flex align-items-center justify-content-center" style="width: 64px; height: 64px; background: #F4F6F8;">
                    <img :src="require('@/assets/img/Icon Container (2).png')" alt="Sécurité" style="width: 32px; height: auto;">
                 </div>
              </div>
              <div>
                <h6 class="fw-bold mb-2 text-dark-brown">Sécurité et transparence garanties</h6>
                <p class="text-secondary mb-0" style="font-size: 0.95rem; line-height: 1.6;">Vos transferts internationaux sont sécurisés par des protocoles avancés et conformes aux normes réglementaires</p>
              </div>
            </div>

            <custom-button label="Télécharger l'App" />
          </div>
        </div>
      </div>
    </main>
    
    <!-- Testimonials Section -->
    <testimonials-section />
    
    <!-- FAQ Section -->
    <faq-section />

    <!-- Final CTA Section -->
    <section class="final-cta-section">
      <div class="container h-100 position-relative">
        
        <div class="row justify-content-center text-center pt-5 position-relative z-index-10">
          <div class="col-lg-8">
            <h2 class="text-white fw-bold mb-3" style="font-size: 1.8rem;">
              Vous avez choisi Nolido, et<br>
              <span class="position-relative d-inline-block">
                vous avez raison...
                <svg class="underline-svg" viewBox="0 0 200 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12 C 50 6, 150 6, 195 10" stroke="#F5A847" stroke-width="2.5" stroke-linecap="round"/>
                </svg>
              </span>
            </h2>
            <button class="btn btn-download-cta rounded-pill mt-2">
              Télécharger maintenant
            </button>
          </div>
        </div>

        <!-- Absolute Positioned Images (Desktop) -->
        <div class="phone-wrapper d-none d-lg-block">
           <img :src="require('@/assets/img/last_section_phone.png')" alt="Nolido App" class="phone-app-img">
        </div>

        <div class="collage-wrapper d-none d-lg-block">
           <img :src="require('@/assets/img/last_section.png')" alt="Communaute Nolido" class="collage-img">
        </div>

        <!-- Stacked Layout for Mobile/Tablet -->
         <div class="row align-items-center mt-5 d-flex d-lg-none">
          <div class="col-12 text-center mb-4">
             <div class="collage-wrapper">
                <img :src="require('@/assets/img/last_section.png')" alt="Communaute Nolido" class="img-fluid collage-img">
             </div>
          </div>
          <div class="col-12 text-center p-0">
            <div class="phone-wrapper">
              <img :src="require('@/assets/img/last_section_phone.png')" alt="Nolido App" class="img-fluid phone-app-img">
            </div>
          </div>
        </div>
      </div>
    </section>

    <app-footer />
  </div>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
import CustomButton from "@/components/CustomButton.vue";
import TestimonialsSection from '@/components/TestimonialsSection.vue';
import FaqSection from '@/components/FaqSection.vue';

export default {
  name: 'AboutNLite',
  components: {
    Navbar,
    AppFooter,
    CustomButton,
    TestimonialsSection,
    FaqSection
  }
}
</script>

<style scoped>
.gray-card {
  background-color: #F2F3F5;
  border-radius: 20px;
  border: none;
  box-shadow: none !important;
}

h2, h3, .hero-title {
  font-family: 'TangoSans', sans-serif !important;
}

.text-dark-brown {
  color: #2F2113 !important;
}

.nlite-hero {
  background-color: #2F2113;
  min-height: 100vh;
  padding-top: 140px; /* Increased top padding */
  padding-bottom: 60px; /* Added bottom padding for left content */
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.nlite-logo {
  height: 40px;
  width: auto;
}

.hero-title {
  font-size: 3rem; /* Reduced from 3.5rem */
  font-weight: 700;
  line-height: 1.2;
}

.hero-desc {
  font-size: 1rem; /* Reduced from 1.1rem */
  font-weight: 300;
  line-height: 1.6;
  max-width: 500px;
}

.underline-svg {
  position: absolute;
  bottom: 5px;
  left: 0;
  width: 100%;
  height: auto;
}

.hero-image-wrapper {
  position: relative;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin-bottom: -60px; /* Counteract section padding to keep image at bottom */
}

.hero-illustration-img {
  max-width: 100%;
  height: auto;
  max-height: 80vh;
  object-fit: contain;
}

.feature-img {
  max-width: 100%;
  width: 100%;
  height: auto;
  border-radius: 20px;
}

.blob-bg {
  position: absolute;
  width: 100%;
  height: 80%;
  background: url('~@/assets/img/bande_gauche.png') no-repeat center center;
  background-size: contain;
  opacity: 0.3;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
}

.blob-left {
  left: -20%;
  transform: translateY(-50%) rotate(180deg);
}

.blob-right {
  right: -20%;
}

.underline-svg-title {
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
}

.underline-svg-feature {
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 100%;
}

.mb-6 {
  margin-bottom: 6rem !important;
}

@media (max-width: 991px) {
  .hero-title {
    font-size: 2.2rem;
  }
  
  .nlite-hero {
    padding-bottom: 4rem;
    height: auto;
    min-height: auto;
  }
  
  .hero-image-wrapper {
    margin-top: 3rem;
    justify-content: center;
  }
  
  .hero-illustration-img {
    max-height: 400px;
  }
  
  .mb-6 {
    margin-bottom: 4rem !important;
  }
  
  .blob-bg {
    width: 150%;
    left: -25%;
    opacity: 0.2;
  }
}

/* Final CTA Styles */
.final-cta-section {
  background-color: #2F2113;
  position: relative;
  overflow: hidden;
  height: 700px;
  padding-top: 2rem;
  background-image: url('~@/assets/img/bande_gauche.png');
  background-position: left 50px;
  background-repeat: no-repeat;
  background-size: 350px auto;
  margin-top: 0; 
}

.btn-download-cta {
  background-color: #eebb89;
  color: #2F2113;
  font-weight: 700;
  border: none;
  font-size: 0.95rem;
  padding: 0.6rem 2rem;
  box-shadow: 0 4px 0 #c29568;
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;
  z-index: 10;
}

.btn-download-cta:hover {
  transform: translateY(2px);
  box-shadow: 0 2px 0 #c29568;
}

.phone-wrapper {
  position: absolute;
  bottom: -40px;
  left: 5%;
  z-index: 5;
  width: 280px; 
}

.phone-app-img {
  width: 100%;
  height: auto;
}

.collage-wrapper {
  position: absolute;
  bottom: 60px;
  right: 2%;
  z-index: 5;
  width: 360px;
}

.collage-img {
  width: 100%;
  height: auto;
  transform: rotate(3deg);
  border-radius: 12px;
}

@media (max-width: 991px) {
  .final-cta-section {
    height: auto;
    min-height: 500px;
    padding-bottom: 0;
    background-image: none;
    padding-top: 3rem;
  }
  
  .phone-wrapper {
    position: relative;
    bottom: 0;
    left: 0;
    margin-top: 2rem;
    margin-bottom: -10px;
    display: inline-block;
  }
  
  .collage-wrapper {
    position: relative;
    bottom: 0;
    right: 0;
    display: inline-block;
  }
  
  .collage-img {
    transform: rotate(0);
  }
}
</style>